module.exports = __webpack_public_path__ + "static/media/smallMedal_1.6f5d20a7.png";